import { render, staticRenderFns } from "./MultimediaUpload.vue?vue&type=template&id=515ebe18&scoped=true"
import script from "./MultimediaUpload.vue?vue&type=script&lang=ts"
export * from "./MultimediaUpload.vue?vue&type=script&lang=ts"
import style0 from "./MultimediaUpload.vue?vue&type=style&index=0&id=515ebe18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ebe18",
  null
  
)

export default component.exports